/* *@Description: 导入日志 */
<template>
  <div class="import-log import-log-box2">
    <el-dialog
      :title="$t('导入日志')"
      :width="'900px'"
      @opened="opened"
      @close="close"
      :close-on-click-modal="false"
      :model-value="dialogVisible"
      top="10vh"
    >
      <div class="left">
        <el-button
          type="primary"
          plain
          icon="Search"
          @click="handleQuery"
          :loading="loading"
          >{{ $t('查询') }}</el-button
        >
        <el-button plain icon="RefreshRight" @click="resetSearch">{{
          $t('清除')
        }}</el-button>
      </div>
      <br />
      <div class="form-box">
        <el-form
          :model="queryParams"
          ref="seach"
          :inline="true"
          label-position="top"
          label-suffix=":"
          class="el-form-search"
        >
          <el-form-item :label="$t('操作时间开始')" prop="startTime">
            <el-date-picker
              v-model="queryParams.startTime"
              value-format="YYYY-MM-DD HH:mm:ss"
              format="YYYY-MM-DD HH:mm:ss"
              :placeholder="$t('操作时间开始')"
            />
          </el-form-item>
          <el-form-item :label="$t('操作时间结束')" prop="endTime">
            <el-date-picker
              v-model="queryParams.endTime"
              value-format="YYYY-MM-DD HH:mm:ss"
              format="YYYY-MM-DD HH:mm:ss"
              :placeholder="$t('操作时间结束')"
            />
          </el-form-item>
        </el-form>
      </div>
      <avue-crud
        ref="params"
        :data="tableList"
        :option="crudOption"
        :page="page"
        @size-change="sizeChange"
        @current-change="currentChange"
      >
        <template #menu="{ row }">
          <el-button
            v-if="row.importState !== 1"
            plain
            icon="Download"
            :title="$t('下载')"
            @click="download(row)"
          />
          <el-button
            v-if="row.errorOssUrl"
            plain
            icon="Failed"
            :title="$t('错误日志下载')"
            @click="download(row, true)"
          />
        </template>
      </avue-crud>
    </el-dialog>
  </div>
</template>

<script setup name="ImportLog">
import {
  reactive,
  toRefs,
  watch,
  defineProps,
  defineEmits,
  getCurrentInstance
} from 'vue';
import { importLog, logDownload } from '@/api/common';
import { $t } from '@/plugins/i18n';
import {
  avueSearchOrBtnHide,
  GetTodayDate,
  downLoadFile
} from '@/utils/commonFun';
import { ElMessage } from 'element-plus';
import { DynamicDictModel } from '@/utils/dictModules/model';
const dynamicDictModel = new DynamicDictModel();
const DICT = dynamicDictModel.init($t);
const { proxy } = getCurrentInstance();
const props = defineProps({
  dialogVisible: {
    type: Boolean,
    default: false
  },
  moduleService: {
    type: String,
    default: ''
  }
});
const { dialogVisible, moduleService } = toRefs(props);
const data = reactive({
  isShowFirst: false,
  tableList: [],
  timer: null,
  isTimer: false,
  loading: false,
  // 查询参数
  queryParams: {
    current: 1,
    size: 20,
    startTime: GetTodayDate()[0], //开始时间
    endTime: GetTodayDate()[1], //结束时间
    moduleService: ''
  },
  crudOption: {
    ...avueSearchOrBtnHide,
    menuWidth: '150px',
    height: '400px',
    column: [
      {
        label: $t('任务名称'),
        prop: 'taskName'
      },
      {
        label: $t('处理状态'),
        prop: 'importState',
        type: 'select',
        dicData: DICT.fileStatus
      },
      {
        label: $t('处理结果'),
        prop: 'errorMsg',
        overHidden: true
      },
      {
        label: $t('导入人员编码'),
        prop: 'createBy'
      },
      {
        label: $t('导入人员姓名'),
        prop: 'createByName'
      },
      {
        label: $t('导入时间'),
        prop: 'createTime'
      }
    ]
  },
  // 翻页
  page: {
    total: 0,
    currentPage: 1,
    pageSize: 20
  },
  isSuccess: false
});
const {
  queryParams,
  crudOption,
  page,
  tableList,
  timer,
  isTimer,
  loading,
  isSuccess
} = toRefs(data);
const emit = defineEmits(['update:dialogVisible']);

// 定时器 每3秒调用一次接口
const interval = () => {
  clearInterval(timer.value);
  timer.value = setInterval(() => {
    getList();
  }, 3000);
};

// 打开弹窗
function opened() {
  queryParams.value.moduleService = moduleService.value || '';
  getList();
}

// 搜索
function handleQuery() {
  queryParams.value.current = 1;
  page.value.currentPage = 1;
  getList();
}

// 重置查询
function resetSearch() {
  queryParams.value = {
    current: 1,
    size: 20,
    startTime: GetTodayDate()[0], //开始时间
    endTime: GetTodayDate()[1], //结束时间
    moduleService: moduleService.value || ''
  };
  proxy.resetForm('seach');
}

function sizeChange(val) {
  page.value.currentPage = 1;
  page.value.pageSize = val;
  getList();
}

function currentChange(val) {
  page.value.currentPage = val;
  getList();
}

// 获取列表
async function getList() {
  queryParams.value.current = page.value.currentPage;
  queryParams.value.size = page.value.pageSize;
  // 1、校验区间开始时间不能大于结束时间
  const startTime = new Date(queryParams.value.startTime).getTime();
  const endTime = new Date(queryParams.value.endTime).getTime();
  if (startTime >= endTime) {
    ElMessage.warning($t('开始时间不能大于结束时间'));
    return false;
  }
  loading.value = true;
  await importLog(queryParams.value)
    .then(res => {
      loading.value = false;
      if (res.code === 1) {
        tableList.value = res.data.records;
        page.value.total = res.data.total;
        isSuccess.value = tableList.value.some(item => item.importState === 2);
        isSuccess.value && emit('refreshList');
      } else {
        ElMessage.error($t(msg));
      }
    })
    .catch(() => {
      loading.value = false;
    });
}

// 下载
async function download(row, errFlag = false) {
  const params = errFlag ? [row.errorOssUrl] : [row.ossUrl];
  try {
    await logDownload(params).then(res => {
      if (res.code === 1) {
        downLoadFile(res.data[0].downloadSignedUrl);
      } else {
        ElMessage.error($t(res.msg));
      }
    });
  } catch (error) {
    console.log(error);
  }
}

//  关闭
function close() {
  emit('update:dialogVisible', false);
}

watch(
  [tableList, dialogVisible],
  ([nVal, newVal]) => {
    if (nVal) {
      // 1 初始化
      isTimer.value = false;
      // 2 当状态有进行中，设置开启定时器状态为true
      nVal.forEach(v => {
        if (v.importState === 1) {
          isTimer.value = true;
          interval();
          return;
        }
      });
      // 3 当状态中没有进行中，关闭定时器
      if (!isTimer.value) {
        clearInterval(timer.value);
        timer.value = null;
      }
    }
    if (!newVal) {
      clearInterval(timer.value);
      timer.value = null;
    }
  },
  { immediate: true, deep: true }
);
</script>

<style lang="scss"></style>
